import { render, staticRenderFns } from "./SidebarModal.vue?vue&type=template&id=c86f2e2a&"
import script from "./SidebarModal.vue?vue&type=script&lang=js&"
export * from "./SidebarModal.vue?vue&type=script&lang=js&"
import style0 from "./SidebarModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/partybox.pl/httpdocs/crazyshop/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c86f2e2a')) {
      api.createRecord('c86f2e2a', component.options)
    } else {
      api.reload('c86f2e2a', component.options)
    }
    module.hot.accept("./SidebarModal.vue?vue&type=template&id=c86f2e2a&", function () {
      api.rerender('c86f2e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/vue/components/modal/SidebarModal.vue"
export default component.exports